import React, { useState, useRef, useEffect } from "react"

import {
  LoginPageContainer,
  LoginPageContent,
  CoverLogoContainer,
  CoverHeaderContainer,
  LoginPageWrapper,
  ModalTitle,
  ModalText,
  ModalContainer,
  CdprLoginButtonContainer
} from './styles';
import { themeColor } from "../../layout/global-style";
import useEventListener from '../../../utils/useEventListener';

import {  Modal } from "../../content/modal"
import { useIntl, FormattedMessage } from "gatsby-plugin-intl"
import { useLocation } from "@reach/router";
import { useAuth } from "../../../services/auth";
import { Compass } from "../../atoms/compass/index"

import Title from '../../atoms/title/index'
import Logo from '../../atoms/logo/index'
import { Subtitle } from '../../atoms/subtitle/index'
import Button from '../../atoms/button/index'
import { Loader } from '../../atoms/loader/index'
import {CDPA} from "../../atoms/icon";


const pageMobileHeight = () => {
  return typeof window !== `undefined` && window.innerWidth < 1024 ? window.innerHeight + `px` : '100vh';
}

const openNewWindow = ({ url, title = '', width = 400, height = 600 }) => {
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const _width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
  const _height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

  const systemZoom = 1;//_width / window.screen.availWidth;
  const left = (_width - width) / 2 / systemZoom + dualScreenLeft
  const top = (_height - height) / 2 / systemZoom + dualScreenTop
  const newWindow = window.open(url, title,
    `dependent=${1}, alwaysOnTop=${1}, alwaysRaised=${1}, alwaysRaised=${1}, directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,copyhistory=no, width=${width / systemZoom}, height=${height / systemZoom}, top=${top}, left=${left}`);

  if (window.focus) newWindow.focus();

  return newWindow;
}

const useAuthPopup = () => {
  const [authWindow, setWindow] = useState(null);
  const [popup, setPopup] = useState({});
  const timer = useRef();
  const { hostname } = useLocation();
  const { loginUser } = useAuth();

  useEffect(() => {
    if (!authWindow) return;

    const cleanupInterval = () => {
      if (timer.current === null) return;
      console.log("[Auth Window] cleanup watcher interval")
      clearInterval(timer.current);
      timer.current = null;
    }

    const watcher = () => {
      if (authWindow === null) {
        cleanupInterval();
        console.log("[Auth Window] closed externalny")
      } else if (authWindow !== null && !authWindow.closed) {
        authWindow.focus();
        console.log("[Auth Window] focus")
      } else if (authWindow !== null && authWindow.closed) {
        cleanupInterval();
        setWindow(null);
        console.log("[Auth Window] closed")
      }

      if (authWindow) {
        console.log("[Auth Window] watcher", { closed: authWindow.closed })
      }
    }

    const onMessage = event => {
      console.log("[On Message]", event.data);
      const { data, error, code } = event.data
      if (!code) return;
      try {

        if (data && code === 200) {
          loginUser(data);
        }
        if (error) {
          setPopup({
            isOpen: true,
            isError: true,
            maxWidth: 700,
            children: <ErrorMessage onClose={() => setPopup({
              maxWidth: 700, isOpen: false
            })} />
          });
        }
      }
      catch (e) {
        console.log("[On Message]", e);
      }
      finally {
        if (authWindow) {
          console.log("[Auth Window] window focus and close")
          authWindow.focus();
          authWindow.close();
        } else {
          console.log("[Auth Window] unable to close window as is gone")
        }
      }
    }

    window.addEventListener('message', onMessage, false);
    timer.current = setInterval(watcher, 1000)
    return () => {
      window.removeEventListener('message', onMessage);
      cleanupInterval();
    }
  }, [authWindow])

  useEffect(() => {
    const { isError } = popup || {};
    if (!isError && !authWindow) setPopup(null);
  }, [authWindow])

  return [popup,
    (channel) => {
      setPopup({ isLoading: true /*, isOpen: true*/ });
      setWindow(openNewWindow({ url: `https://${hostname}/api/comicbook/authenticate/${channel}`, width: 428, height: 700 }))
    }
  ]
}

const Popup = ({ children, isError, ...rest }) => {
  return (
    <Modal
      isClose={false}
      frameColor={isError ? themeColor.red : themeColor.white}
      btnFontColor={themeColor.white}
      maxWidth={'430'}
      innerPadding={64}
      minHeight={'400'}
      {...rest}
    >
      {children}
    </Modal>
  )
}

const ErrorMessage = ({ onClose }) => <ModalContainer>
  <ModalTitle><FormattedMessage id='error.access.denied' /></ModalTitle>
  <ModalText><FormattedMessage id='error.please.cdpr' /></ModalText>
  <Button onClick={onClose} >
    <FormattedMessage id='label.ok' />
  </Button>
</ModalContainer>

const LoginPage = () => {
  const [pageHeight, setPageHeight] = useState(pageMobileHeight());
  const intl = useIntl();
  const [popupProps, onAuth] = useAuthPopup();

  useEventListener('resize', () => setPageHeight(pageMobileHeight()), typeof window !== `undefined` ? window : null);
  return (
    <LoginPageContainer height={pageHeight} id="loginPage">
      <Compass />
      <LoginPageWrapper>
        <LoginPageContent>
          <CoverLogoContainer>
            <Logo />
          </CoverLogoContainer>
          <CoverHeaderContainer>
            <Title color={themeColor.black} messageid={"app.title"} />
            <Subtitle color={themeColor.black}><FormattedMessage id='app.subtitle' /></Subtitle>
          </CoverHeaderContainer>
          <CdprLoginButtonContainer>
            <Button onClick={() => onAuth("cdpa")} >
              <CDPA color={themeColor.red} />
              {`${intl.formatMessage({ id: `sign.in.with.title` })} ${intl.formatMessage({ id: `sign.in.with.cdpr` })}`}
            </Button>
          </CdprLoginButtonContainer>
        </LoginPageContent>
      </LoginPageWrapper>
      <Loader isFull isTransitionMode={false} isLoading={popupProps? popupProps.isLoading : false } top={'auto'} zIndex={1} color={themeColor.black} bgColor={themeColor.white} />
     <Popup {...popupProps} />
    </LoginPageContainer>
  )
};

export default LoginPage;
